import { apiFetch } from "../utils/apiFetch"

export function saveApplicationDraft(data: any) {
  return apiFetch("/api/applications", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  })
}

export function getApplicationDrafts() {
  return apiFetch("/api/applications")
}

export function updateApplicationStatus(id: string, status: string) {
  return apiFetch(`/api/applications/${id}/status`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ status })
  })
}

export function updateApplicationDraft(id: string, data: any) {
  return apiFetch(`/api/applications/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  })
}

export function deleteApplicationDraft(id: string) {
  return apiFetch(`/api/applications/${id}`, { method: "DELETE" })
}

export function getApplicationById(id: string) {
  return apiFetch(`/api/applications/${id}`)
}

export function duplicateApplicationDraft(id: string) {
  return apiFetch(`/api/applications/${id}/duplicate`, { method: "POST" })
}
